interface VideoSpec {
    code: string,
    libelle: string,
    select: boolean,
    key: string
}

const liste_videos: Array<VideoSpec> = [
    {
        code: '624563226?h=ec09644496',
        libelle: 'Prérequis et connexion à la plateforme',
        select: true,
        key: 'presentation'
    },
    {
        code: '624568626?h=1367e06f2a',
        libelle: 'Compléter son dossier académique',
        select: false,
        key: 'dossier-academique'
    },
    {
        code: '624576818?h=edf780372c',
        libelle: 'Remplir son dossier administratif',
        select: false,
        key: 'dossier-administratif'
    },
    { code: '624582434?h=97b4c29b13', libelle: 'Visualiser et signer son contrat', select: false, key: 'contrat' },
    {
        code: '653620989?h=a322d3c839',
        libelle: 'Visualiser et signer la convention',
        select: false,
        key: 'signature-convention'
    },
    {
        code: '668161810?h=48ab010ab6',
        libelle: "Remplir et signer l'annexe de convention",
        select: false,
        key: 'remplir-signer-annexe-convention'
    },
    {
        code: '669495132?h=eb5d72566d',
        libelle: "Déclarer l'organisation des écrits et gérer les intervenants",
        select: false,
        key: 'organisation-ecrits-intervenants'
    },
    {
        code: '671137829?h=12a2756f48',
        libelle: 'Déclarer et signer les fiches horaires des intervenants',
        select: false,
        key: 'fiches-horaires-intervenants'
    },
    {
        code: '671100057?h=dd6a889164',
        libelle: "Signer la fiche horaires en tant qu'intervenant",
        select: false,
        key: 'fiche-horaires-intervenant'
    },
    {
        code: '712114218?h=b349e2b471',
        libelle: 'Déclarer les incompatibilités et les disponibilités pour un examinateur',
        select: false,
        key: 'incompatibilites-disponibilites-examinateur'
    },
    {
        code: '836068646?h=841c8e5867',
        libelle: 'Webinaire de prise en main de la solution de VIATIQUE sur tablette - TP',
        select: false,
        key: 'webinaire-viatique-tablette-tp'
    },
    {
        code: '836476925?h=0b4492df02',
        libelle: 'Webinaire de prise en main de la solution de VIATIQUE sur tablette - Hors TP',
        select: false,
        key: 'webinaire-viatique-tablette-hors-tp'
    }
]

export { liste_videos }

export function getVideoSpec(key: string): VideoSpec {
    let videoSpec = liste_videos.find((video) => video.key === key)

    if (videoSpec === undefined) {
        videoSpec = { code: '', libelle: '', select: false, key: '' }
    }
    return videoSpec
}
